import React from "react";
import NumberFormat from "react-number-format";

import { getRange } from "aible";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

import {
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  ReferenceLine,
  ResponsiveContainer,
  Cell
} from "recharts";

import styles from "./style.module.css";

const CustomToolTip = (props) => {
  const { active, payload, netImpactLabel, label, decimalScale } = props;
  if (!active || !payload) {
    return null;
  }

  const tData =
    props && props.payload && props.payload.length > 0 && props.payload[0].payload
      ? props.payload[0].payload
      : undefined;

  const sigFigs = tData
    ? Math.abs(tData[netImpactLabel]) > 1000
      ? 0
      : Math.abs(tData[netImpactLabel]) < 1
        ? undefined
        : 2
    : undefined;

  return tData ? (
    <div className={styles.cTooltip} style={{ fontSize: "14px" }}>
      <div className={styles.tExtra}>{tData.x}</div>
      {tData.x !== "Current State" && (
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Model: "}</div>
          <strong>{tData.name}</strong>
        </div>
      )}
      <div className={styles.tBody}>
        <div className={styles.tLabel}>{netImpactLabel + ":"}</div>
        <strong>
          <NumberFormat
            value={tData[netImpactLabel]}
            displayType={"text"}
            thousandSeparator={true}
            decimalScale={decimalScale !== undefined ? decimalScale : sigFigs}
          />
        </strong>
      </div>
    </div>
  ) : (
    <div />
  );
};

const CustomLabel = (props) => {
  const { active, payload, label } = props;

  return (
    <text textAnchor="start" className={styles.aLabel}>
      <tspan
        x={
          props.position === "insideTopLeft"
            ? props.value
              ? 250 / props.value.length
              : 20
            : props.viewBox.x + props.viewBox.width / 2 - 33
        }
        y={props.viewBox.y + props.offset}
      >
        {props.value}
      </tspan>
    </text>
  );
};

const colors = ["red", "green", "pink", "yellow"];

class ResultsGraph extends React.Component {
  render() {
    const { data, isContinuous, isQuickRun, netImpactLabel, decimalScale } = this.props;
    let negativeValue = false;
    let positiveValue = false;

    for (let d in data) {
      if (!negativeValue && (data[d].Impact || data[d].Processed) < 0) {
        negativeValue = true;
      }
      if (!positiveValue && (data[d].Impact || data[d].Processed) > 0) {
        positiveValue = true;
      }
    }

    const xLabel = "";
    const yLabel = "";

    const yDataMin = Math.min.apply(
      Math,
      data.map((p) => p[netImpactLabel] || 0)
    );
    const yDataMax = Math.max.apply(
      Math,
      data.map((p) => p[netImpactLabel] || 0)
    );

    let [low, high] = getRange(yDataMin, yDataMax, true);

    if (!negativeValue) {
      low = Math.max(0, low);
    }

    if (!positiveValue) {
      high = Math.max(0, high);
    }

    const yDomain = [low, high];

    return (
      <div style={{ height: "100%" }}>
        <div className={styles.runPlot} id="runPlot" style={{ height: "100%" }}>
          <ResponsiveContainer>
            <BarChart
              margin={{
                top: 20,
                right: 20,
                bottom: 60,
                left: 20
              }}
              data={data}
              onClick={() => {}}
            >
              <XAxis type="category" dataKey="x" name={xLabel} tickFormatter={(tick) => tick.toLocaleString()}></XAxis>
              <YAxis
                type="number"
                dataKey={netImpactLabel}
                name={yLabel}
                tickFormatter={(tick) => tick.toLocaleString()}
                domain={yDomain}
                interval={0}
              ></YAxis>
              {negativeValue ? <ReferenceLine y={0} stroke="#000" /> : ""}
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip
                content={
                  <CustomToolTip
                    netImpactLabel={isContinuous ? "Total Cost" : isQuickRun ? "Failure Count" : netImpactLabel}
                    decimalScale={decimalScale}
                  />
                }
              />
              <Bar dataKey={netImpactLabel}>
                {data.map((p, index) => (
                  <Cell key={`cell-${index}`} fill={p.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default ResponsiveChart(ResultsGraph);
